import React from 'react';
import './SupportPage.css';
import AnimatedSection from './components/AnimatedSection';

const SupportPage = () => {
  return (
    <AnimatedSection>
      <div className="support-container">
        <h1>Support Center</h1>
        <p>Have questions or need assistance? Contact us using the information below.</p>

        <div className="contact-info">
          <h2>Contact Information</h2>
          <p>Email: support@example.com</p>
          <p>Phone: +1 (123) 456-7890</p>
        </div>

        <h2>Get in Touch</h2>
        <form className="support-form">
          <label htmlFor="name">Your Name:</label>
          <input type="text" id="name" name="name" required />

          <label htmlFor="email">Your Email:</label>
          <input type="email" id="email" name="email" required />

          <label htmlFor="message">Your Message:</label>
          <textarea id="message" name="message" required></textarea>

          <button type="submit">Send</button>
        </form>
      </div>
    </AnimatedSection>
  );
};

export default SupportPage;
